import Vue from 'vue';
import { BootstrapVue, IconsPlugin, ModalPlugin, ToastPlugin } from 'bootstrap-vue';

import { VeeValidate } from '@validations';
import router from '@/router';
import store from '@/store';
import App from './App.vue';

// Global Components
import './global-components';

// Global Methods
import './global-methods';

// 3rd party plugins
import '@/libs/portal-vue';
import '@/libs/acl';
import { applyDataVolleyAdminAbility } from '~/libs/acl/dataVolleyAdmin';
import ability from '@/libs/acl/ability';
import { Actions } from '~/libs/acl/actions';
import { Subjects } from '~/libs/acl/subjects';
import UUID from 'vue-uuid';

// BSV Plugin Registration
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

//UUID
Vue.use(UUID);

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

require('@core/scss/vue/libs/vue-wizard.scss');
require('@core/scss/vue/libs/vue-select.scss');

VeeValidate.localize('sl');

Vue.config.productionTip = false;

// the page the browser asked for, before the router may redirect it
const requestedPath = window.location.pathname + window.location.search;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');

// The per-user DataVolley administrator ability needs /auth/me, so it arrives after the first
// navigation (mounting first keeps an expired-token redirect to login working). A reload on a page
// that needs it (DataVolley settings) was redirected meanwhile: open it again.
applyDataVolleyAdminAbility()
    .then(() => {
        const requested = router.resolve(requestedPath).route;
        if (requested.meta.resource === Subjects.DataVolleyAdmin && router.currentRoute.fullPath !== requested.fullPath
            && ability.can(Actions.manage, Subjects.DataVolleyAdmin))
            router.replace(requested.fullPath).catch(() => {});
    })
    .catch(e => console.log(e));
